import { render, staticRenderFns } from "./range-price.vue?vue&type=template&id=9038abae&scoped=true"
import script from "./range-price.vue?vue&type=script&lang=js"
export * from "./range-price.vue?vue&type=script&lang=js"
import style0 from "./range-price.vue?vue&type=style&index=0&id=9038abae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9038abae",
  null
  
)

export default component.exports